"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Settings_1 = __importDefault(require("./Settings"));
exports.default = Settings_1.default;
